import React from 'react'
import '../BrandPlugins/BrandPlugin.css'
const BrandPlugins = ({ title, img }) => {
  return (
    <div className='container-plugins-principal'>
      <h3 className='title-brand'>{title}</h3>
      <div className="container-logos">
        <img src="/brands/Woocommerce_logo.svg" alt="" />
        <img src="/brands/Magento_logo.svg" alt="" />
        <img src="/brands/Prestashop_logo.svg" alt="" />
        <img src="/brands/VTEX_logo.svg" alt="" />
        <img src="/brands/API_logo.svg" alt="" />
      </div>
    </div>
  )
}
export default BrandPlugins